'use client';
import { useState, Suspense } from 'react';
import { CldImage } from 'next-cloudinary';
import AnimationImage from '../animation-image/animation-image';

type StackedCardsImageProps = {
    url: string;
    cloudinaryId: string;
    alt?: string;
};

// rest includes the inspectorProps props for live preview
export const StackedCardsImage = (props: StackedCardsImageProps) => {
    const { url, cloudinaryId, alt = '', ...rest } = props;
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const aspectRatio = 'aspect-20/17';

    return (
        <Suspense fallback={<div />}>
            <div className="h-full max-w-4xl mx-auto">
                <AnimationImage isImageLoaded={isImageLoaded}>
                    <div className={`relative ${aspectRatio}`}>
                        <CldImage
                            {...rest}
                            // priority
                            className="z-0 w-full h-full"
                            src={`${cloudinaryId}`}
                            alt={alt}
                            width={1600}
                            height={1600}
                            sizes="(max-width: 767px) 100vw,(min-width: 768px) 40vw"
                            onLoad={() => setIsImageLoaded(true)}
                        />
                    </div>
                </AnimationImage>
            </div>
        </Suspense>
    );
};

export default StackedCardsImage;
